import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinusSquare, faPlusSquare} from "@fortawesome/free-solid-svg-icons";
import ConsignmentFromToDateTime from "../stolen/ConsignmentFromToDateTime";
import ConsignmentStatusBadge from "./ConsignmentStatusBadge";
import ConsignmentTrackingPortalButton from "./ConsignmentTrackingPortalButton";
import ConsignmentImagesGallery from "./ConsignmentImagesGallery";
import ConsignmentProofOfDeliveryButton from "./ConsignmentProofOfDeliveryButton";
import ConsignmentFreightTable from "./ConsignmentFreightTable";
import ConsignmentLiveTrackingHeading from "./ConsignmentLiveTrackingHeading";
import WaypointComponent from "../common/WaypointComponent";


interface ConsignmentTableProps {
    consignments: CustomerAPIConsignmentResponse[];
    onToggleExpand: (consignmentId: number) => void;
    expandedIds: Set<number>;
}

const ConsignmentTable = (props: ConsignmentTableProps) => {

    const { consignments } = props;

    return (
        <table className="table">
            <thead>
            <tr>
                <th scope="col">&nbsp;</th>
                <th scope="col">Date / Time</th>
                <th scope="col">Delivery Reference</th>
                <th scope="col">Your Reference</th>
                <th scope="col">Vehicle</th>
                <th scope="col">To</th>
                <th scope="col">Status</th>
                <th scope="col"><ConsignmentLiveTrackingHeading /></th>
            </tr>
            </thead>
            <tbody>

            {consignments.length < 1 &&
                <tr>
                    <td colSpan={9}>
                        <p className="text-center">No Deliveries found</p>
                    </td>
                </tr>
            }

            {consignments.map(consignment => {
                const expanded = props.expandedIds.has(consignment.id);
                const { delivery } = consignment;

                return (
                    <React.Fragment key={consignment.id}>
                        <tr style={{
                            borderBottomStyle: expanded ? 'hidden' : 'inherit'
                        }}>
                            <td onClick={() => props.onToggleExpand(consignment.id)}>
                                <FontAwesomeIcon icon={expanded ? faMinusSquare : faPlusSquare} size="lg"/>
                            </td>
                            <td>
                                <ConsignmentFromToDateTime fromDateTime={delivery.from} toDateTime={delivery.to}/>
                            </td>
                            <td>
                                {consignment.ref}
                            </td>
                            <td>
                                {consignment.customerRef}
                            </td>
                            <td>
                                {consignment.deliveryVehicle?.vehicleTypeDescription} <br />
                                {consignment.deliveryVehicle?.registration}
                            </td>
                            <td>
                                <WaypointComponent waypoint={consignment.delivery} detailed={expanded} />
                            </td>
                            <td>
                                <p><ConsignmentStatusBadge consignment={consignment} /></p>
                            </td>
                            <td>
                                {consignment.trackingPortalLink &&
                                    <>
                                        <div className="d-xl-none"><strong>Live Tracking</strong><br /></div>
                                        <ConsignmentTrackingPortalButton consignment={consignment} />
                                    </>
                                }
                            </td>
                        </tr>
                        {expanded &&
                            <tr>
                                <td>&nbsp;</td>
                                <td colSpan={8}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-6">
                                                <ConsignmentFreightTable freight={consignment.freight} />
                                            </div>
                                            <div className="col-6" style={{paddingTop: '45px'}}>
                                                <ConsignmentImagesGallery consignment={consignment} hidden={!expanded} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <ConsignmentProofOfDeliveryButton consignment={consignment} />
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        }
                    </React.Fragment>
                )})}

            </tbody>
        </table>
    )

}

export default ConsignmentTable;
